module.exports = __webpack_public_path__ + "static/media/Image.edf1a425.png";